declare namespace $ {

	export class $bog_builderui_tooltip extends $mol_pop_over {
	}
	
}

//# sourceMappingURL=tooltip.view.tree.d.ts.map